export enum LoaderRows {
  SM = 4,
  LG = 11,
}
export enum LoaderColums {
  LG = 2,
  SM = 4,
}
